import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { CalculationStatisticSkuClassResponse } from '@ydistri/api-sdk';
import { useTemplateOrCalculation } from '../../../hooks/useTemplateOrCalculation';
import { ReduxState } from '../../../store';
import StatisticDimensionSection from './components/StatisticDimensionSection';
import { useGetStatsSkuClassesQuery } from './apiCalculationStatistics';

const SectionSkuClasses: React.FC = () => {
  const templateOrCalculation = useTemplateOrCalculation();
  const departmentId = useSelector((state: ReduxState) => state.statistics.departmentId);
  const { data, isLoading } = useGetStatsSkuClassesQuery({
    calculationId: templateOrCalculation.id,
    departmentId,
  });

  const getItemTitle = useCallback(
    (item: CalculationStatisticSkuClassResponse) => item.skuClass.name,
    [],
  );
  const getItemKey = useCallback(
    (item: CalculationStatisticSkuClassResponse) => `${item.skuClass.id}`,
    [],
  );

  return (
    <StatisticDimensionSection
      title="SKU classes"
      tableId="sku-class-statistics"
      dimensionColumnTitle="SKU class"
      data={data}
      loading={isLoading}
      getItemTitle={getItemTitle}
      getItemKey={getItemKey}
    />
  );
};

export default SectionSkuClasses;
